import { useState } from "react";
import { api } from "@/lib/api";
import { Bell, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Popover, PopoverContent, PopoverTrigger,
} from "@/components/ui/popover";

function fmt(iso) {
  const d = new Date(iso);
  return isNaN(d) ? iso : d.toLocaleString("it-IT", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
}

export function NotificationsBell({ notifications, onRefresh }) {
  const [open, setOpen] = useState(false);
  const unread = notifications.filter((n) => !n.read).length;

  const markAll = async () => {
    await api.post("/notifications/read-all");
    onRefresh();
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button data-testid="notification-bell" className="relative rounded-full h-10 w-10 flex items-center justify-center hover:bg-muted transition-colors">
          <Bell className="h-5 w-5" />
          {unread > 0 && (
            <span data-testid="notification-badge" className="absolute -top-0.5 -right-0.5 min-w-5 h-5 px-1 rounded-full bg-[#D32F2F] text-white text-[11px] font-bold flex items-center justify-center">
              {unread}
            </span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0">
        <div className="flex items-center justify-between px-4 py-3 border-b">
          <p className="font-display font-semibold">Notifiche</p>
          {unread > 0 && (
            <Button size="sm" variant="ghost" data-testid="mark-all-read" onClick={markAll} className="text-xs h-7">
              Segna lette
            </Button>
          )}
        </div>
        <div className="max-h-80 overflow-y-auto">
          {notifications.length === 0 ? (
            <p className="px-4 py-8 text-center text-sm text-muted-foreground">Nessuna notifica</p>
          ) : (
            notifications.map((n) => (
              <div key={n.id} data-testid={`notification-${n.id}`} className={`px-4 py-3 border-b last:border-0 flex gap-3 ${n.read ? "opacity-60" : "bg-accent/40"}`}>
                <CheckCircle2 className="h-5 w-5 text-emerald-600 shrink-0 mt-0.5" />
                <div className="min-w-0">
                  <p className="text-sm leading-snug">{n.message}</p>
                  <p className="text-xs text-muted-foreground mt-1">{fmt(n.created_at)}</p>
                </div>
              </div>
            ))
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
}
